var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgSearch64 = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 64,
  fill: "none",
  viewBox: "0 0 64 64",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M26.472 6.923a1.5 1.5 0 0 1-.807 1.962 24.6 24.6 0 0 0-12.998 12.73A1.5 1.5 0 0 1 9.923 20.4 27.6 27.6 0 0 1 24.51 6.116a1.5 1.5 0 0 1 1.962.807M46.588 30.508c0-5.8-4.701-10.5-10.5-10.5a1.5 1.5 0 0 1 0-3c7.456 0 13.5 6.044 13.5 13.5a1.5 1.5 0 1 1-3 0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M49.713 16.883c-8.005-8.006-20.985-8.006-28.991 0-7.529 7.529-7.977 19.457-1.346 27.51L7.44 56.33a1.5 1.5 0 0 0 2.122 2.121l11.886-11.886c8.046 7.308 20.498 7.078 28.266-.69 8.006-8.006 8.006-20.986 0-28.992m-26.87 2.121c6.834-6.834 17.915-6.834 24.749 0 6.834 6.835 6.834 17.915 0 24.75-6.834 6.833-17.915 6.833-24.749 0-6.834-6.835-6.834-17.915 0-24.75",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch64);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };